export default __webpack_public_path__ + "static/media/GOLD.e689d129.png";